(() => {
  if (window.RPEnquiryAnalytics) return;
  const config = document.querySelector('[data-rp-enquiry-config]')?.dataset || {};
  const preview = config.preview !== 'false';
  const sessionKey = `rpa_contact_draft_${config.theme || 'default'}`;
  const pendingKey = `${sessionKey}_pending`;
  const expiry = 60 * 60 * 1000;
  function stored(key) {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      return value && Date.now() - value.updatedAt < expiry ? value : null;
    } catch { return null; }
  }
  function save(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify({...value, updatedAt:Date.now()})); } catch {}
  }
  function remove(key) {
    try { sessionStorage.removeItem(key); } catch {}
  }
  function track(name, values = {}) {
    if (preview || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== 'function') return;
    const allowed = ['quote_item_count','enquiry_route','contact_location','enquiry_type'];
    const parameters = Object.fromEntries(Object.entries(values).filter(([key]) => allowed.includes(key)));
    window.gtag('event', name, parameters);
  }
  window.RPEnquiryAnalytics = {track};
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="tel:"],a[href^="mailto:"]');
    if (!link) return;
    const contactLocation = link.closest('[data-rp-enquiry-contact],.rp-enquiry-contact-card') ? 'contact_page' : link.closest('.rp-product-enquiry-actions,[data-product-meta]') ? 'product_page' : link.closest('[id*="footer"]') ? 'footer' : 'header';
    track(link.getAttribute('href').startsWith('tel:') ? 'rd_clicked_phone_number' : 'rd_clicked_email', {contact_location:contactLocation});
  });
  function fields(form) {return Array.from(form.elements).filter(field => field.name?.startsWith('contact[') && field.type !== 'hidden');}
  function persist(form) {
    const values = Object.fromEntries(fields(form).map(field => [field.name,field.value]));
    save(sessionKey,{values});
  }
  function init() {
    document.querySelectorAll('[data-rp-enquiry-contact]').forEach(form => {
      if (form.dataset.rpEnquiryReady) return;
      form.dataset.rpEnquiryReady = 'true';
      const success = form.querySelector('[data-rp-enquiry-success]');
      if (success) {
        const pending = stored(pendingKey);
        if (pending) track('rd_submitted_contact_form',{enquiry_type:pending.enquiryType});
        remove(sessionKey); remove(pendingKey);
        success.focus({preventScroll:true});
        return;
      }
      const draft = stored(sessionKey);
      if (draft?.values) fields(form).forEach(field => {if (typeof draft.values[field.name] === 'string') field.value = draft.values[field.name];});
      let timer;
      form.addEventListener('input', () => {clearTimeout(timer);timer = setTimeout(() => persist(form),200);});
      form.addEventListener('change', () => persist(form));
      window.addEventListener('pagehide', () => persist(form));
      form.addEventListener('submit', event => {
        fields(form).filter(field => ['contact[name]','contact[email]','contact[phone]','contact[Delivery address]'].includes(field.name)).forEach(field => {field.value=field.value.trim();});
        if (!form.reportValidity()) {event.preventDefault();return;}
        persist(form);
        const enquiryType = form.elements.namedItem('contact[Enquiry type]')?.value;
        save(pendingKey,{enquiryType:['Parts','Service','Fitment help','Other'].includes(enquiryType) ? enquiryType : 'Other'});
        const button = form.querySelector('[data-rp-enquiry-send]');
        if (button) {
          button.disabled = true;
          form.setAttribute('aria-busy','true');
          setTimeout(() => {if (form.isConnected) {button.disabled=false;form.removeAttribute('aria-busy');}},15000);
        }
      });
    });
  }
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',() => {document.querySelectorAll('[data-rp-enquiry-send]').forEach(button => {button.disabled=false;button.closest('form')?.removeAttribute('aria-busy');});});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

